import { Button, Spin } from "antd";
import { useEffect, useState } from "react";
import StaticIntlTranslator from "shared/components/atoms/StaticIntlTranslator";
import { useRouter } from "next/router";
import api from "shared/infra/services/api";
import { EntityProps } from "../../@types/enrollments";
import handleToEnrollmentContent from "../../utils/handleToEnrollmentContent";
import { Container } from "./styles";

const ItemsToAccessContent = ({
  entity,
  context,
  isProductBundleScreen,
}: ItemsToAccessContentProps) => {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const [courseLessons, setCourseLessons] = useState([]);

  useEffect(() => {
    const handleLession = async () => {
      setIsLoading(true);

      try {
        const lessons = await api.get(
          `/course/${router.query.course_slug}/lesson`,
        );

        setCourseLessons(lessons.data.data);
      } catch {
        setCourseLessons([]);
      }

      setIsLoading(false);
    };

    handleLession();
  }, []);

  return (
    <Container
      noMargin={context === "course" && !courseLessons?.length}
      className="text-plus-btn-container"
    >
      {isLoading ? (
        <Spin />
      ) : isProductBundleScreen ? (
        <></>
      ) : context === "course" && !courseLessons?.length ? (
        <p>
          <StaticIntlTranslator id="common:alreadyEnrolledInThisContent" />
        </p>
      ) : (
        <Button
          className="buy-btn"
          type="primary"
          onClick={() => handleToEnrollmentContent({ entity, context, router })}
        >
          <StaticIntlTranslator id="common:accessTheContent" />
        </Button>
      )}
    </Container>
  );
};

interface ItemsToAccessContentProps {
  entity: EntityProps;
  context: string;
  isProductBundleScreen: boolean;
}

export default ItemsToAccessContent;
